import { render, staticRenderFns } from "./SoliListAvatar.vue?vue&type=template&id=2a6fa93c"
import script from "./SoliListAvatar.vue?vue&type=script&lang=js"
export * from "./SoliListAvatar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports